VLW.controllers.NosVins = class extends VLW.controllers.Home {
	/**
	 * @property {Object.<VLW.BouteillePIXI>} aBouteille
	 */
	constructor(a, b) {
		super(a, b);
		this.constructor.setStyleMenuHover("color_white");
		this.pixi.align            = "tl";
		this.pixi.displacementType = VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_NOSVINS;
		this.isFirstEnterLi        = true;
		this.aBouteille            = {};
		this.filet                 = this.qs("._filets");
		this.img                   = this.qs("._listeImg");
		this.lis                   = [...this.qsa("._listeVins li._vins")];
		this.lis.forEach((elt) => {
			elt.addEventListener("mouseenter", this.onEnterLi);
			elt.addEventListener("mouseleave", this.onLeaveLi);
			elt.style.opacity       = 0;
			elt.style.pointerEvents = "none";
		});
		this._oMask = {
			"1": "linear-gradient(rgba(0, 0, 0, .25) 0%		, rgba(0, 0, 0, .75) 100%)",
			"2": "linear-gradient(rgba(0, 0, 0, .75) 100%	, rgba(0, 0, 0, .25) 100%)",
			"3": "linear-gradient(rgba(0, 0, 0, .5) 0%		, rgba(0, 0, 0, 0) 100%)",
		};
		ThrowPropsPlugin.track(this.filet, "y");
		window.addEventListener("resize", this.onResize, supportsPassive);
		window.containerBouteille      = new PIXI.Container();
		window.containerBouteille.name = "NosVinsBouteilles";
		PIXIAPP.addChild(window.containerBouteille, 9999);
		
	}
	
	animFilet(paused = false) {
		let tl = new TimelineMax({paused});
		tl.addLabel("start");
		tl.set(this.qsa("._filet"), {className: "-=__transitionable"});
		tl.fromTo(this.qsa("._filet"), 1.25, {opacity: 0}, {opacity: .7, ease: Sine.easeInOut}, "start");
		tl.fromTo(this.qsa("._filet"), 1.25, {opacity: 0}, {opacity: .7, ease: Sine.easeInOut}, "start");
		tl.staggerFromTo(this.qsa("._filet"), 1.25, {scaleX: .01}, {scaleX: 1, ease: Sine.easeInOut, clearProps: "transform", onComplete: () => {this.qsa && this.qsa("._filet").map((elt) => elt.classList.add("__transitionable"))}}, .1, "start+=0");
		this.mySplitText2 && tl.staggerFromTo(this.mySplitText2.chars, .75, {opacity: 0, x: 0, rotation: 0, transformOrigin: "50% 0%"}, {opacity: 1, smoothOrigin: true, rotation: 0, transformOrigin: "0% 0%", x: 0, ease: Sine.easeOut}, .05, "start+=0");
		return tl;
	}
	
	introContent(delay = 0) {
		let tl = new TimelineMax();
		tl.set(this.mainElementJS, {opacity: 1});
		tl.staggerFromTo(this.lis, .5, {opacity: 0}, {opacity: 1, ease: Power2.easeOut}, .6, 0);
		tl.staggerFromTo(this.lis, 1, {y: -25}, {y: 0, ease: Sine.easeOut}, .6, 0);
		tl.set(this.lis, {pointerEvents: "auto"}, 1.5);
		return true;
	}
	
	loadPIXIResources() {
		let _loader = new PIXI.loaders.Loader();
		_loader.add("image", this.getPIXIResourcesBackground());
		//_loader.add("displacement", "/images/displacement/nosvins.jpg");
		_loader.load((loader, resources) => {
			this.pixi.resources = resources;
			loader.destroy()
		});
	}
	instanceClean(){
		Object.values(this.aBouteille).forEach((elt=>{
				elt.instanceClean();
		}));
		super.instanceClean();
	}
	
	onRender() {
		this.loadPIXIResources_test();
		this.setSplitText();
		this.tlFilet = this.animFilet(true);
		this.tlFilet.timeScale(1.5);
	}
	/*
	outroPixi(){
		if(!this.controllerToTrig  || !this.controllerToTrig instanceof VLW.controllers.eavVin){
			super.outroPixi();
		}
	}
	*/
	
	outro() {
		super.outro();
		this.lis.forEach((elt) => {
			elt.removeEventListener("mouseenter", this.onEnterLi);
			elt.removeEventListener("mouseleave", this.onLeaveLi);
			
		});
		window.removeEventListener("resize", this.onResize);
		ThrowPropsPlugin.untrack(this.filet);
	}
	
	onResize(e) {
		let _ratioY = Math.min(1,windowSize.height/1200);
		this.img.querySelectorAll("img").forEach((elt)=>{
			elt.style.transform=`scale(${_ratioY}) translate(-50%,-50%)`;
		});
		let _bound = (this.img.querySelector("img").getBoundingClientRect());
		window.containerBouteille.scale.set(_ratioY,_ratioY);
		window.containerBouteille.position.set(Math.round(_bound.left, 0), Math.round(_bound.top, 0));
		// 1200 -> 1000
	}
	
	onLeaveLi(e) {
		let _index = getIndex(e.currentTarget);
		TweenMax.to(e.currentTarget.querySelector("._label"), .5, {"-webkit-mask-image": this._oMask[_index]},);
		broadCaster.BACKGROUND_SHOW.dispatch();
		Object.values(this.aBouteille).forEach((elt) => {elt.outro();});
		TweenMax.delayedCall(.1, this.setFirstEnterLi, [true])
	}
	
	setFirstEnterLi(value) {
		this.isFirstEnterLi = value;
		this.tlFilet.reverse();
	}
	
	loadPIXIResources_test() {
		this.cptZindex  = 0;
		this.aBouteille = {};
		let _loader     = new PIXI.loaders.Loader();
		_loader.add("mask", "/images/mask/bouteille.png");
		[...this.qsa("._listeImg img")].forEach((elt) => {
			_loader.add("bouteille_" + elt.getAttribute("data-id"), elt.getAttribute("src"));
		});
		!VERSION_SMARTP && _loader.load((loader, resources) => {
			this.onResize();
			Object.values(resources).forEach(elt => {
				if (elt.name.match(/bouteille/)) {
					this.aBouteille[elt.name.split("_")[1]] = new VLW.BouteillePIXI(elt, resources.mask, window.containerBouteille, this.cptZindex++);
				}
			});
		});
		return;
	}
	
	onEnterLi(e) {
		if (e.currentTarget.classList.contains("_selected")) {
			//return;
		}
		this.tlFilet.play();
		TweenMax.killDelayedCallsTo(this.setFirstEnterLi);
		!VERSION_SMARTP && broadCaster.BACKGROUND_HIDE.dispatch();
		let _index    = getIndex(e.currentTarget);
		let _id       = e.currentTarget.getAttribute("data-id");
		let bouteille = this.aBouteille[_id];
		let _yTo      = (_index -1) * 190;
		if(this.isFirstEnterLi) {
			TweenMax.set(this.filet,{x: "-50%",y:_yTo});
		}else{
			ThrowPropsPlugin.to(this.filet, {x: "-50%", throwProps: {y: {velocity: "auto", end: (end) => {return _yTo}},}}, .75, 0.35);
		}
		TweenMax.set(this.lis, {className: "-=_selected"});
		TweenMax.set(e.currentTarget, {className: "+=_selected"});
		bouteille && bouteille.intro(this.cptZindex++, this.isFirstEnterLi);
		this.isFirstEnterLi = false;
		window.containerBouteille.children.sort((itemA, itemB) => itemA.zIndex - itemB.zIndex);
		TweenMax.to(e.currentTarget.querySelector("._label"), .5, {"-webkit-mask-image": "linear-gradient(rgba(0, 0, 0, 1) 0%,rgba(0, 0, 0, 1) 100%)", ease: Power2.easeInOut}, 1.15);
		this.lis.forEach((elt) => {
			if (elt !== e.currentTarget) {
				TweenMax.to(elt.querySelector("._label"), .5, {"-webkit-mask-image": this._oMask[getIndex(elt)]},);
			}
		});
	}
};